const dateTimeFormat = 'DD/MM/YYYY';

const constant = {
    dateTimeFormat
}

export { constant };